

































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { IWebManagement } from '@/interface/WebManagement';
import { VueEditor } from 'vue2-editor';
import WebManagementData from '@/data/WebManagementData';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GeneralModule from '@/store/modules/General';
import WebManagementModule from '@/store/modules/WebManagement';
import WebManagementBody from '@/components/Table/WebManagementBody.vue';
import Table from '@/components/Table/Index.vue';
import PreviewPromotion from '@/components/PreviewPromotion.vue';

@Component({
  components: {
    Table,
    VueEditor,
    PreviewPromotion,
    WebManagementBody,
  },
})
export default class WebManagement extends Mixins(ErrorHandleMixin) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  WebManagementInstance = getModule(WebManagementModule, this.$store);

  TableHead = WebManagementData.TableHead;

  dataProp = [];

  file: any = File;

  isImage = false;

  isUpdate = false;

  isShowModal = false;

  isShowPreview = false;

  currentType = 'banner';

  types = [
    { name: 'banner', value: 'banner' },
    { name: 'promotion', value: 'promotion' },
  ];

  currentLang = 'th';

  langSelect = 'th';

  languages = [
    { name: 'th', value: 'th' },
    { name: 'en', value: 'en' },
    { name: 'cn', value: 'cn' },
    { name: 'myr', value: 'mry' },
  ];

  dataWeb: IWebManagement = {
    _id: '',
    url: '',
    description: '',
    status: false,
    sort: 0,
    type: this.currentType,
    lang: this.currentLang,
  };

  @Watch('dataWeb.url', { immediate: true, deep: true })
  checkFile() {
    if (this.dataWeb.url) this.isShowPreview = true;
    else this.isShowPreview = false;
  }

  async created() {
    this.initial();
    this.fetch();
  }

  async fetch() {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.WebManagementInstance.Fetch();
    this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
    this.dataProp = data[this.currentType][this.currentLang];
  }

  uploadImage(files: [any] | { size: number }[]) {
    const [file] = files;
    this.dataWeb.url = URL.createObjectURL(file);
    this.file = file;
    this.isImage = true;
  }

  async submit() {
    this.GeneralInstance.toggleLoading(true);
    await this.upLoadImageApi();
    const { status } = await this.WebManagementInstance.Create(this.dataWeb);
    this.GeneralInstance.toggleLoading(false);
    this.checkError(status);
    this.initial();
  }

  async upLoadImageApi() {
    const formData = new FormData();
    formData.append('name', this.file.name);
    formData.append('imgFile', this.file);
    const { data, status } = await this.WebManagementInstance.UploadImg(formData);
    this.dataWeb.url = data;
    this.checkError(status);
  }

  editData(value: { _id: any; url: any; description: any; sort: any; status: any }) {
    const {
      _id,
      url,
      description,
      sort,
      status,
    } = value;
    this.isUpdate = !this.isUpdate;
    this.isShowModal = true;
    this.dataWeb._id = _id;
    this.dataWeb.url = url;
    this.dataWeb.description = description;
    this.dataWeb.sort = sort;
    this.dataWeb.status = status;
  }

  async deleteData(value: { _id: string; url: string }) {
    this.GeneralInstance.toggleLoading(true);
    const { _id, url } = value;
    const name = url.split('/images/')[1];
    await this.WebManagementInstance.DeleteImg({ name });
    this.dataWeb._id = _id;
    const { status } = await this.WebManagementInstance.Delete(this.dataWeb);
    this.checkError(status);
    this.fetch();
    this.GeneralInstance.toggleLoading(false);
  }

  async onUpdate() {
    this.GeneralInstance.toggleLoading(true);
    if (this.file.lastModified) {
      await this.upLoadImageApi();
    }
    const { status } = await this.WebManagementInstance.Update(this.dataWeb);
    this.checkError(status);
    this.isUpdate = !this.isUpdate;
    this.isShowModal = !this.isShowModal;
    this.initial();
    this.GeneralInstance.toggleLoading(false);
  }

  toggleShowModal() {
    this.isShowModal = !this.isShowModal;
    this.onReset();
  }

  setLang(value: string) {
    this.dataWeb.lang = value;
  }

  selectType(value: string) {
    this.currentType = value;
    this.initial();
  }

  selectLang(value: string) {
    this.file = File;
    this.currentLang = value;
    this.initial();
  }

  onReset() {
    this.file = File;
    this.dataWeb = {
      _id: '',
      url: '',
      description: '',
      status: false,
      sort: 0,
      type: this.currentType,
      lang: this.currentLang,
    };
  }

  initial() {
    this.file = File;
    this.dataWeb.sort = 0;
    this.dataWeb.description = '';
    this.fetch();
  }
}
